import { Navigate, RouteObject } from "react-router";
import { OfferIndexRoute } from "@/routes/processes/[processId]/htz/offers/_components/offer-index-route";
import { OfferRoute } from "@/routes/processes/[processId]/htz/offers/[offerId]/offer-route";
import { DataRoute } from "@/routes/processes/[processId]/htz/offers/[offerId]/data/data-route";
import { PositionsRoute } from "@/routes/processes/[processId]/htz/offers/[offerId]/positions/positions-route";
import { AddressesAndContactsRoute } from "@/routes/processes/[processId]/htz/offers/[offerId]/addresses-and-contacts/addresses-and-contacts-route";

export const htzOffersRoutes: RouteObject[] = [
  {
    index: true,
    element: <OfferIndexRoute />,
  },
  {
    path: ":offerId",
    element: <OfferRoute />,
    children: [
      {
        index: true,
        element: <Navigate to="data" replace />,
      },
      {
        path: "data",
        element: <DataRoute />,
      },
      {
        path: "positions",
        element: <PositionsRoute />,
      },
      {
        path: "addresses-and-contacts",
        element: <AddressesAndContactsRoute />,
      },
    ],
  },
];
